import SecondarySelect from '@/components/ui/custom/secondary/SecondarySelect';
import SecondaryTextArea from '@/components/ui/custom/secondary/SecondaryTextArea';
import TagInput from '@/components/tags/TagInput';
import useListService from '@/data/hook/useListService';
import { toolsQueryKeys } from '@/data/services/querykeys';
import { useController, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { LessonFields } from './LessonBoxForm';
import LinksSection from './LinksSection';
import LessonManageBank from './LessonManageBank';

export default function LessonDetailForm() {
  const { watch, setValue, register, control } = useFormContext<LessonFields>();
  const { results: tools } = useListService(toolsQueryKeys.list());
  const { t } = useTranslation('translation', {
    keyPrefix: 'courseBox.form',
  });

  const toolsOptions = tools.map(tool => ({
    label: tool.name,
    value: tool.id,
  }));

  const { field } = useController({
    name: 'tool',
    control: control,
  });

  return (
    <fieldset className="flex flex-col gap-2">
      <SecondaryTextArea
        {...register('description')}
        label={{
          text: t('objective'),
          position: 'outside',
        }}
      />
      <LessonManageBank control={control} />
      <TagInput
        className={{ base: 'w-full', label: 'text-14 font-500' }}
        value={watch('tagsIds')}
        onChange={tagsIds => setValue('tagsIds', tagsIds)}
      />
      <SecondarySelect
        {...field}
        label={t('tool')}
        options={toolsOptions}
        className={{
          base: 'p-2.5 px-4 rounded-xl',
          icon: 'text-neutral',
        }}
      />
      <LinksSection control={control} />
    </fieldset>
  );
}
